import React from 'react';
import ShowMore from 'react-show-more';

function stripHtmlTags(html) {
    return html.replace(/<[^>]*>/g, '');
}

export default function Menu(props) {
	
	return (
		<div className={props.showMenu ? "menu d-flex" : "menu d-flex hide"}>
			<div className='row d-flex w-100'>
				<div className='col-12 mx-auto'>
					<div className='podcast_title px-4 pt-3 foo-bar'>
						<ShowMore lines={3}>{ props.episode.contentSnippet }</ShowMore>
					</div>
				</div>
				<div className='col-12 d-block d-md-block text-right'>
					<a href={'https://studio.hubhopper.com'} target="_blank" rel="noopener noreferrer">
						<div className='listenonhh px-4 text-center'>
							<span className='text-white'>Powered by </span> <span style={{fontFamily:'Kimberley'}}>hubhopper</span> Studio
						</div>
					</a>
				</div>
			</div>
		</div>
	);
}
